import React, { useEffect } from "react";
import "./EmtHome.scss";
import CaseHistoryComponent from "../CaseHistory/CaseHistory";

const EmtHomeComponent: React.FC<any> = () => {
  useEffect(() => {}, []);

  return (
    <div className="emt-home-container">
      <CaseHistoryComponent isFromEMTHome={true}></CaseHistoryComponent>
    </div>
  );
};

export default EmtHomeComponent;
